import { render, staticRenderFns } from "./smartLogisticsRule.vue?vue&type=template&id=2d23b8bc&scoped=true"
import script from "./smartLogisticsRule.vue?vue&type=script&lang=js"
export * from "./smartLogisticsRule.vue?vue&type=script&lang=js"
import style0 from "./smartLogisticsRule.vue?vue&type=style&index=0&id=2d23b8bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d23b8bc",
  null
  
)

export default component.exports